// action - state management
import { LOGIN, LOGOUT, SET_USER, SET_LOGIN } from './actionType';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null
};

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN: {
            const { user, userLoggedIn } = action.payload;
            if (userLoggedIn) {
                window.location.reload();
            }
            if (user) {
                user.hasAccess = (permissionID) => {
                    if (user?.Role?.accessIDs.split(',').includes(permissionID) || user?.user_type === 'Admin') return true;
                    return false;
                };
            }
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                userLoggedIn,
                user
            };
        }
        case SET_USER: {
            const { user } = action.payload;
            user.hasAccess = (permissionID) => {
                if (user?.Role?.accessIDs.split(',').includes(permissionID)) return true;
                return false;
            };
            return {
                ...state,
                isLoggedIn: false,
                isInitialized: true,
                user
            };
        }
        case SET_LOGIN: {
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
